import React from 'react';
import PropTypes from 'prop-types';
import { getClassName } from 'utils/ui/classes';
import { getCircleButtonClass } from './buttons/CircleButton';
import { colors } from '../../constants/colors';

const baseClasses = ['flex', 'space-x-2'];

const IconTextDisplay = ({
  children,
  icon,
  className,
  text,
  color,
  dataTestId,
}) => (
  <div
    data-testid={dataTestId}
    className={getClassName(baseClasses, className)}
  >
    <div
      data-testid="div-7c3464e0"
      className={getCircleButtonClass({
        color,
        size: 'small',
      })}
    >
      {icon}
    </div>
    {children}
    {text && (
      <span data-testid="span-9b2088f3" className="text-sm break-words">
        {text}
      </span>
    )}
  </div>
);

IconTextDisplay.propTypes = {
  color: PropTypes.oneOf(Object.values(colors)),
  children: PropTypes.any,
  icon: PropTypes.node.isRequired,
  text: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};

IconTextDisplay.defaultProps = {
  color: colors.gray,
};

export default IconTextDisplay;
